export default {
    throwError({settings, obj, msg}) {
        var json = {
            msg: msg || `ajax code: ${obj.code}`,
            req: settings,
            res: obj
        };

        setTimeout(() => {
            console.error(JSON.stringify(json));
        }, 0);
    }
};
